import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import BudgetTypeList from '@app/views/BudgetType/List';
import { memo } from 'react';

export default memo(
  withIfUser(BudgetTypeList)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
